/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { SVGProps } from 'react';

const LanguageIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="LanguageIcon">
    <path
      d="M3.417 14.25v4.333H7.75v2.167h-6.5v-6.5h2.167Zm17.333 0v6.5h-6.5v-2.167h4.333V14.25h2.167ZM12.082 4.5l4.767 11.917h-2.335l-1.3-3.25H8.781l-1.298 3.25H5.15L9.916 4.5h2.166ZM11 7.625 9.648 11h2.7l-1.35-3.375ZM7.75 1.25v2.167H3.417V7.75H1.25v-6.5h6.5Zm13 0v6.5h-2.167V3.417H14.25V1.25h6.5Z"
      fill="var(--quicklinkIcon)"
      stroke="var(--secondaryBackground)"
    />
  </svg>
);

export default LanguageIcon;
